import { render, staticRenderFns } from "./DIASRealEstatePledges.vue?vue&type=template&id=6c83cac8&"
import script from "./DIASRealEstatePledges.vue?vue&type=script&lang=js&"
export * from "./DIASRealEstatePledges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports